import Request from "./request";

export default class Api {
  login(username, password) {
    return Request.create.post("login", { username, password });
  }

  refresh() {
    return Request.create.post("refresh");
  }

  logout() {
    return Request.create.post("logout");
  }

  conversations(history = false, page = 1, pageSize = 25) {
    return Request.create.get(
      "conversations?history=" +
        history +
        "&page=" +
        page +
        "&pageSize=" +
        pageSize
    );
  }

  acceptConversation(id) {
    return Request.create.post("conversations/" + id + "/accept");
  }

  rejectConversation(id, note) {
    return Request.create.post("conversations/" + id + "/reject", { note });
  }

  resolveConversation(id, response) {
    return Request.create.post("conversations/" + id + "/resolve", {
      response
    });
  }

  searchBooks(text, page = 1, pageSize = 25){
    return Request.create.post("experts/books/search?page="+page+"&pageSize="+pageSize,{text});
  }
}
